// TYPING SEARCH ANIMATION
document.addEventListener("DOMContentLoaded", function () {
  const input = document.querySelector(".typing-search-bar");
  if (!input) return;

  const texts = [
    "Search By Product or Brands",
    "Luxury Bags, Shoes, Dresses...",
    "Top Trending Brands...",
    "Features...",
    "New Arrivals — Explore Now"
  ];

  let textIndex = 0;
  let charIndex = 0;
  let isDeleting = false;
  let currentText = "";

  function type() {
    const fullText = texts[textIndex];

    if (isDeleting) {
      currentText = fullText.substring(0, charIndex--);
    } else {
      currentText = fullText.substring(0, charIndex++);
    }

    input.setAttribute("placeholder", currentText);

    // Typing speed
    let speed = isDeleting ? 50 : 80;

    // When full text complete
    if (!isDeleting && charIndex === fullText.length) {
      speed = 400; // Wait before delete
      isDeleting = true;
    }

    // When deleted completely
    if (isDeleting && charIndex === 0) {
      isDeleting = false;
      textIndex = (textIndex + 1) % texts.length;
      speed = 400;
    }

    setTimeout(type, speed);
  }

  type();
});


// FOOTER MOBILE TAB
function initFooterAccordion() {
  if ($(window).width() <= 750) {
    // Remove old handlers before adding new ones
    $(".footer-block--link_list-lx h2.footer-block__heading")
      .off("click.footerAccordion")
      .on("click.footerAccordion", function () {
        $(this)
          .parent(".footer-block--link_list-lx")
          .toggleClass("open")
          .find(".footer-block__details-content")
          .slideToggle();
      });
  } else {
    // Remove accordion styles and events for desktop
    $(".footer-block--link_list-lx h2.footer-block__heading")
      .off("click.footerAccordion");

    $(".footer-block--link_list-lx")
      .removeClass("open")
      .find(".footer-block__details-content")
      .removeAttr("style");
  }
}

$(document).ready(function () {
  initFooterAccordion();

  $(window).on("resize", function () {
    initFooterAccordion();
  });
});








// PRODUCT SLIDER IMAGE'S
document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".lxMetafieldSwiperImages", {
    slidesPerView: "auto",
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: ".lx-meta-next",
      prevEl: ".lx-meta-prev",
    }
  });
});


// PRODUCT TAB'S 
$(".product-lx-tabs-btn-item").click(function(){
  $(".product-lx-tabs-btn-item").removeClass('active');
  $(this).addClass('active');
  var btn_id = $(this).attr('btn-id');

  $('.product-lx-tab-content-item').removeClass('active');
  $(this).parents('.product-lx-tabs-wrapper').find('.product-lx-tab-content-item[tab-id="' + btn_id + '"]').addClass('active');
});

$(".lx-faq-wrapper-q").click(function(){
  $(this).parent('.lx-faq-wrapper').toggleClass('active');
  $(this).parent('.lx-faq-wrapper').find('.lx-faq-wrapper-a').slideToggle();
});

$(document).ready(function() {
  $("details.mega-menu").each(function() {
    const $detail = $(this);
    const $summary = $detail.find("summary.header__menu-item");
    const $content = $detail.find(".mega-menu__content");

    // Hover in
    $summary.add($content).on("mouseenter", function() {
      $detail.attr("open", true);
      $detail.closest(".template-index sticky-header")
        .removeClass("header-wrapper--transparent")
        .addClass("open-mega");
    });

    // Hover out
    $summary.add($content).on("mouseleave", function(e) {
      if (!$(e.relatedTarget).closest($detail).length) {
        $detail.removeAttr("open");
        $detail.closest(".template-index sticky-header")
          .removeClass("open-mega")
          .addClass("header-wrapper--transparent");
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {

  // Function to update form and sync controls
  function updateVariant(formId, variantId, variantWrapper) {
    const form = document.getElementById(formId);
    if (!form) return;

    // Update hidden input
    form.querySelector('.product-variant-id').value = variantId;

    // Sync buttons
    variantWrapper.querySelectorAll('button').forEach(btn => {
      btn.classList.toggle('selected', btn.dataset.size === variantId);
    });

    // Sync dropdown
    const dropdown = variantWrapper.querySelector('.variant-dropdown');
    if (dropdown) dropdown.value = variantId;
  }

  // Variant buttons click
  document.querySelectorAll('.variant-buttons button').forEach(button => {
    button.addEventListener('click', function() {
      const variantId = this.dataset.size;
      const variantWrapper = this.closest('.product-action---variant');
      const formId = variantWrapper.dataset.formId;
      updateVariant(formId, variantId, variantWrapper);
    });
  });

  // Variant dropdown change
  document.querySelectorAll('.variant-dropdown').forEach(dropdown => {
    dropdown.addEventListener('change', function() {
      const variantId = this.value;
      const variantWrapper = this.closest('.product-action---variant');
      const formId = variantWrapper.dataset.formId;
      updateVariant(formId, variantId, variantWrapper);
    });
  });

});





// document.addEventListener("DOMContentLoaded", () => {
//   const sliders = document.querySelectorAll(".card-product-swiper");

//   sliders.forEach((slider) => {
//     new Swiper(slider, {
//       loop: true,
//       slidesPerView: 1,
//       pagination: {
//         el: slider.querySelector(".swiper-pagination"),
//         clickable: true,
//       },
//       navigation: {
//         nextEl: slider.querySelector(".swiper-button-next"),
//         prevEl: slider.querySelector(".swiper-button-prev"),
//       },
//     });
//   });
// });

function initCardProductScroll(selector = ".card-product-scroll") {
  document.querySelectorAll(selector).forEach((card) => {
    const wrapper = card.querySelector(".card-scroll-wrapper");
    const prevBtn = card.querySelector(".scroll-prev");
    const nextBtn = card.querySelector(".scroll-next");

    // Exit if wrapper doesn't exist
    if (!wrapper) return;

    // ---- FUNCTION TO UPDATE DISABLE STATES ----
    function updateArrows() {
      const maxScroll = wrapper.scrollWidth - wrapper.clientWidth;

      // PREV DISABLE
      if (prevBtn) {
        if (wrapper.scrollLeft <= 5) {
          prevBtn.classList.add("disabled");
        } else {
          prevBtn.classList.remove("disabled");
        }
      }

      // NEXT DISABLE
      if (nextBtn) {
        if (wrapper.scrollLeft >= maxScroll - 5) {
          nextBtn.classList.add("disabled");
        } else {
          nextBtn.classList.remove("disabled");
        }
      }
    }

    // ---- ARROW CLICK EVENTS ----
    if (nextBtn && !nextBtn.hasAttribute("data-scroll-init")) {
      nextBtn.setAttribute("data-scroll-init", "true");
      nextBtn.addEventListener("click", () => {
        wrapper.scrollBy({ left: wrapper.offsetWidth, behavior: "smooth" });
        setTimeout(updateArrows, 300);
      });
    }

    if (prevBtn && !prevBtn.hasAttribute("data-scroll-init")) {
      prevBtn.setAttribute("data-scroll-init", "true");
      prevBtn.addEventListener("click", () => {
        wrapper.scrollBy({ left: -wrapper.offsetWidth, behavior: "smooth" });
        setTimeout(updateArrows, 300);
      });
    }

    // ---- UPDATE ON MANUAL SCROLL ----
    if (!wrapper.hasAttribute("data-scroll-init")) {
      wrapper.setAttribute("data-scroll-init", "true");
      wrapper.addEventListener("scroll", updateArrows);
    }

    // ---- INIT ----
    updateArrows();
  });
}

// Call the function
initCardProductScroll();



$(".collection__title_btn").click(function() {
  $(".collection__title_btn").removeClass('active');
  $(this).addClass('active');
  var btn__id = $(this).attr('collection_id');

  $('.featured__collection_item').removeClass('active');
  $(this).parents('.collection').find('.featured__collection_item[collection_id="' + btn__id + '"]').addClass('active');
});



function reInitWishlistButtons() {
  // Check if Swym is loaded
  if (window._swat) {
    // Re-initialize all Swym buttons on the page
    // You can replace "body" with a specific container selector (e.g., "#product-grid") for better performance
    window._swat.initializeActionButtons("#product-grid");
    console.log("Swym buttons re-initialized");
  } else {
    // Retry if _swat is not yet ready (unlikely on "Load More" but good for safety)
    document.addEventListener("swym:loaded", function() {
      window._swat.initializeActionButtons("#product-grid");
    });
  }
}

 if (!customElements.get('variant-image-switcher')) {
    class VariantImageSwitcher extends HTMLElement {
      constructor() {
        super();
        this.mainImage = this.querySelector('.js-card-main-image');
        this.swatches = this.querySelectorAll('.color-swatch-trigger');

        if (!this.mainImage || this.swatches.length === 0) return;

        this.swatches.forEach(swatch => {
          swatch.addEventListener('click', this.onSwatchClick.bind(this));
        });
      }

      onSwatchClick(event) {
        event.preventDefault();
        const clickedSwatch = event.currentTarget;
        
        // 1. Remove active class from all swatches in this card
        this.swatches.forEach(s => s.classList.remove('is-active'));
        
        // 2. Add active class to the clicked swatch
        clickedSwatch.classList.add('is-active');

        // 3. Swap the image
        const newSrc = clickedSwatch.dataset.src;
        const newSrcset = clickedSwatch.dataset.srcset;

        if (newSrc && newSrcset) {
          this.mainImage.setAttribute('src', newSrc);
          this.mainImage.setAttribute('srcset', newSrcset);
        }
      }
    }

    customElements.define('variant-image-switcher', VariantImageSwitcher);
  }



    function formatMoney(amount, locale, currency) {
    const loc = locale || 'en-US';
    const curr = currency || 'USD';

    return new Intl.NumberFormat(loc, {
      style: "currency",
      currency: curr,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount / 100);
  }

  if (!customElements.get('free-shipping')) {
    class FreeShipping extends HTMLElement {
      constructor() {
        super();
        this.giftAdded = false;
        this.processingGift = false;
        this.locale = 'en-US';
        this.currency = 'USD';
        this.fixedIcons = false;
      }

      connectedCallback() {
        let total = parseInt(this.dataset.cartTotal, 10);
        let showGift = this.dataset.showGift === 'true';
        let showShipping = this.dataset.showShipping === 'true';
        this.fixedIcons = this.dataset.fixedIcons === 'true';

        this.locale = this.dataset.locale;
        this.currency = this.dataset.currency;

        let shippingMinimum = Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1));
        let giftMinimum = this.dataset.giftMinimum ? Math.round(parseInt(this.dataset.giftMinimum, 10) * (Shopify.currency.rate || 1)) : 0;
        let giftVariantId = this.dataset.giftVariantId;

        let activeGoals = [];

        if (showShipping) {
          activeGoals.push({
            type: 'shipping',
            value: shippingMinimum
          });
        }
        if (showGift && giftMinimum > 0) {
          activeGoals.push({
            type: 'gift',
            value: giftMinimum
          });
        }

        activeGoals.sort((a, b) => a.value - b.value);

        let maxThreshold = activeGoals.length > 0 ? activeGoals[activeGoals.length - 1].value : shippingMinimum;

        let percentage = this.calculateBarPercentage(total, activeGoals, maxThreshold);
        this.style.setProperty('--percentage', percentage);

        this.updateIcons(activeGoals, maxThreshold, total);

        let nextGoal = null;

        for (let goal of activeGoals) {
          if (total < goal.value) {
            nextGoal = goal;
            break;
          }
        }

        if (nextGoal) {
          if (nextGoal.type === 'shipping') {
            this.showShippingProgress(total, nextGoal.value);
          } else {
            this.showGiftProgress(total, nextGoal.value);
          }
        } else {
          if (activeGoals.length > 0) {
            let lastGoal = activeGoals[activeGoals.length - 1];
            if (lastGoal.type === 'shipping') {
              this.showShippingSuccess();
            } else {
              this.showGiftSuccess();
            }
          } else {
            if (showShipping) this.showShippingSuccess();
          }
        }

        if (showGift && giftMinimum > 0 && total >= giftMinimum) {
          if (giftVariantId && !this.giftAdded && !this.processingGift) {
            this.addGiftToCart(giftVariantId);
          }
        }
      }

      calculateBarPercentage(total, activeGoals, maxThreshold) {
        if (!this.fixedIcons || activeGoals.length < 2) {
          return (maxThreshold > 0) ? Math.min(total / maxThreshold, 1) : 1;
        }

        const goal1 = activeGoals[0].value;
        const goal2 = activeGoals[1].value;

        if (total < goal1) {
          return (total / goal1) * 0.5;
        } else if (total >= goal1 && total < goal2) {
          const range = goal2 - goal1;
          const progressInRange = total - goal1;
          const relativePercent = progressInRange / range;
          return 0.5 + (relativePercent * 0.5);
        } else {
          return 1;
        }
      }

      showShippingProgress(total, threshold) {
        this.hideAllTexts();
        const container = this.querySelector('.fs-shipping-messages');
        const remainingText = container.querySelector('.free-shipping--text-remaining');
        const amountSpan = remainingText.querySelector('span');

        if (container) container.classList.remove('fs-hidden');
        if (remainingText) remainingText.style.display = 'block';

        let diff = threshold - total;
        if (amountSpan) amountSpan.innerHTML = formatMoney(diff, this.locale, this.currency);

        const fullText = container.querySelector('.free-shipping--text-full');
        if (fullText) fullText.style.display = 'none';
      }

      showGiftProgress(total, threshold) {
        this.hideAllTexts();
        const container = this.querySelector('.fs-gift-messages');
        const remainingText = container.querySelector('.free-gift--text-remaining');
        const amountSpan = remainingText.querySelector('span');

        if (container) container.classList.remove('fs-hidden');
        if (remainingText) remainingText.style.display = 'block';

        let diff = threshold - total;
        if (amountSpan) amountSpan.innerHTML = formatMoney(diff, this.locale, this.currency);

        const fullText = container.querySelector('.free-gift--text-full');
        if (fullText) fullText.style.display = 'none';
      }

      showShippingSuccess() {
        this.hideAllTexts();
        const container = this.querySelector('.fs-shipping-messages');
        const remainingText = container.querySelector('.free-shipping--text-remaining');
        const fullText = container.querySelector('.free-shipping--text-full');

        if (container) container.classList.remove('fs-hidden');
        if (remainingText) remainingText.style.display = 'none';
        if (fullText) fullText.style.display = 'block';
      }

      showGiftSuccess() {
        this.hideAllTexts();
        const container = this.querySelector('.fs-gift-messages');
        const remainingText = container.querySelector('.free-gift--text-remaining');
        const fullText = container.querySelector('.free-gift--text-full');

        if (container) container.classList.remove('fs-hidden');
        if (remainingText) remainingText.style.display = 'none';
        if (fullText) fullText.style.display = 'block';
      }

      hideAllTexts() {
        const shipMsg = this.querySelector('.fs-shipping-messages');
        const giftMsg = this.querySelector('.fs-gift-messages');
        if (shipMsg) shipMsg.classList.add('fs-hidden');
        if (giftMsg) giftMsg.classList.add('fs-hidden');
      }

      updateIcons(activeGoals, maxThreshold, total) {
        const shippingIcon = this.querySelector('.shipping-milestone');
        const giftIcon = this.querySelector('.gift-milestone');

        if (shippingIcon) shippingIcon.classList.add('fs-hidden');
        if (giftIcon) giftIcon.classList.add('fs-hidden');

        activeGoals.forEach((goal, index) => {
          let icon = (goal.type === 'shipping') ? shippingIcon : giftIcon;
          if (icon) {
            icon.classList.remove('fs-hidden');
            let pos;

            if (this.fixedIcons) {
              if (activeGoals.length > 1) {
                pos = (index === 0) ? 50 : 100;
              } else {
                pos = 100;
              }
            } else {
              pos = (goal.value / maxThreshold) * 100;
            }

            icon.style.left = `${pos}%`;

            if (total >= goal.value) icon.classList.add('achieved');
            else icon.classList.remove('achieved');
          }
        });
      }

      async addGiftToCart(variantId) {
        this.processingGift = true;
        try {
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();

          const giftInCart = cart.items.some(item =>
            item.variant_id === parseInt(variantId)
          );

          if (giftInCart) {
            this.giftAdded = true;
            this.processingGift = false;
            return;
          }

          const formData = {
            items: [{
              id: variantId,
              quantity: 1
            }]
          };

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          });

          if (response.ok) {
            this.giftAdded = true;
            if (typeof window.theme !== 'undefined' && window.theme.cart) window.theme.cart.refresh();
            else {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              document.dispatchEvent(new CustomEvent('theme:cartchanged'));
            }
            this.showGiftNotification();
          }
        } catch (error) {
          console.error(error);
        } finally {
          this.processingGift = false;
        }
      }

      showGiftNotification() {
        const notification = document.createElement('div');
        notification.className = 'free-gift-notification';
        notification.innerHTML = '🎁 Free gift added to your cart!';
        document.body.appendChild(notification);
        setTimeout(() => notification.classList.add('show'), 100);
        setTimeout(() => {
          notification.classList.remove('show');
          setTimeout(() => notification.remove(), 300);
        }, 3000);
      }
    }
    customElements.define('free-shipping', FreeShipping);
  }